import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import LocaleStrings from "Languages";
import Navigation from "./components/navigation";
import ProposalForm from "./components/proposal-form";
import ProposalFormBuilder from "./components/proposalform/form-builder";
import AddReviewer from "./components/add-reviewer";
import ReviewCriteria from "./components/review-criteria";
import Publish from "./components/publish";
import {
  fetchProposalStep,
  checkProposalFormStatus,
  checkProposalReviewer,
  checkProposalReviewCriteria,
} from "ProposalAction";

class ProposalWizard extends Component {
  constructor(props) {
    super(props);
    this.state = { sessionShowenable: false };
  }

  componentDidMount() {
    this.props.checkProposalFormStatus(this.props.session);
    this.props.checkProposalReviewer(this.props.session);
    this.props.checkProposalReviewCriteria(this.props.session);
    this.props.fetchProposalStep("step_1");
  }

  render() {
    let { ProposalStep, deviceSize } = this.props;

    return (
      <div
        className="panel-body scrollable-content-85"
        style={{ height: "82vh", overflowY: "auto" }}
        // style={{ height: deviceSize.height - 70, width: "100%" }}
      >
        <Navigation />

        {ProposalStep == "step_1" ? (
          <ProposalForm history={this.props.history} />
        ) : ProposalStep == "step_2" ? (
          <ProposalFormBuilder />
        ) : ProposalStep == "step_3" ? (
          <AddReviewer />
        ) : ProposalStep == "step_4" ? (
          <ReviewCriteria />
        ) : ProposalStep == "step_5" ? (
          <Publish history={this.props.history} comesfrom='Add' />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    ProposalStep: state.ProposalStep,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  fetchProposalStep,
  checkProposalFormStatus,
  checkProposalReviewer,
  checkProposalReviewCriteria,
})(ProposalWizard);
